import * as types from './mutation-types';
import collect from 'collect.js';

export default {
    namespaced: true,
    strict: true,
    state: {
        products: []
    },
    mutations: {
        [types.PRODUCTS](state, products) {
            state.products = products;
        }
    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        getInfoPanel({ state }, name) {
            return new Promise((resolve, reject) => {
                const products = collect(state.products);
                let product = products.firstWhere('id', name);

                if (product) {
                    resolve({
                        type: 'product',
                        title: product.name,
                        panel: product.info_panel
                    });
                } else {
                    reject();
                }
            });
        }
    },
    getters: {}
};
